<kl-gps-geo-marker (fenceUpdated)="onFenceUpdate($event)">
</kl-gps-geo-marker>
